import React, { useState } from "react";
import Google from '../../../../assets/svg/signIn_logos/google_icon.svg'
import Github from '../../../../assets/svg/signIn_logos/github_icon.svg'
import { ReactComponent as NewUser } from "../../../../assets/images/user.svg"
import { Alert, Button, Icon, Modal } from "antd";
import './initialPage.css';
import { useHistory } from "react-router-dom";
import { useToast } from "../../../../helpers/commonFunction";
import { useDispatch } from "react-redux";
import { Http } from "../../../../helpers/axois";
import firebase from "firebase";
import { saveDetails, setUser } from "../../../../stateManager/store/user/actions";
import { logger } from "../../../../constant/winston";
import { decode } from "jsonwebtoken";
import style from "../../auth.module.sass";
import { redirectOnLogin } from "../../../../helpers/util";

interface Iprops {
    // setLoginState: (state: string) => void;
}

const initialUser = {
    loading: false,
    available: false,
    showError: false,
    username: ""
}


const InitialPage = (props:Iprops) => {


    const [social, setSocial] = useState<{ provider?: string, data?: any }>({ provider: "", data: null });
    const [showUserName, setShowUserName] = useState(false);
    const [usernameAvailable, setUsernameAvailable] = useState<{ loading?: boolean, available?: boolean, showError?: boolean, inputCheck?: boolean, username?: string }>(initialUser);
    const { ErrorToast, SuccessToast } = useToast()
    const history = useHistory();
    const dispatch = useDispatch();

    const authHttp = ({ provider, data }: any) => {
        setUsernameAvailable({ ...usernameAvailable, loading: true })
        let apiEndPoint = provider === "google" ? "auth/google" : "auth/github";
        Http.post(apiEndPoint, data).subscribe(
            (res: any) => {
                setUsernameAvailable({ ...usernameAvailable, loading: false })
                const userInfo = decode(res.token);
                dispatch(setUser({ user: userInfo }));
                localStorage.setItem("studioToken", res.token);
                localStorage.setItem("studioRefreshToken", res.refreshToken);
                setShowUserName(false);
                if(redirectOnLogin(res.token)) {
                    return
                }
                SuccessToast('Login successful')
                history.push("/home");
            },
            err => {
                setUsernameAvailable({ ...usernameAvailable, loading: false })
                if (err.type === "UNAME_NOT_FOUND") {
                    setShowUserName(true);
                    setSocial({ provider, data });
                } else if (err.type === "EMAIL_PRESENT") {
                    setUsernameAvailable(initialUser);
                    setShowUserName(false);
                    ErrorToast((err && err.message) ? err.message : 'Email already exists')
                } else if (err.type === "EMAIL_NOT_FOUND") {
                    setUsernameAvailable(initialUser);
                    setShowUserName(false);
                    ErrorToast((err && err.message) ? err.message : 'Email does not exist')
                }
            }
        );
    };

    const socialSiginIn = (socialType: any) => {
        if (socialType === "google") {
            let provider = new firebase.auth.GoogleAuthProvider();
            firebase
                .auth()
                .signInWithPopup(provider)
                .then(function (result: any) {
                    try {
                        const google = {
                            email: result.user && result.user.email,
                            accessToken: result.credential && result.credential.accessToken,
                            firstName: result.user.displayName
                        };
                        authHttp({ provider: socialType, data: google });
                        // delete google.accessToken
                        let { accessToken, ...details }: any = google
                        dispatch(saveDetails({...details, loginType: socialType}));
                        // setShowUserName(true);
                        // setSocial({ provider: social, data: google })
                    } catch (e) {
                        logger.error("ee", e);
                    }
                })
                .catch(error => {
                    logger.error("error google firebase", error);
                    if (error.code !== "auth/popup-closed-by-user" && error.code !== "auth/cancelled-popup-request") {
                        ErrorToast(error.message)
                    }
                });
        } else if (socialType === "github") {
            let provider = new firebase.auth.GithubAuthProvider();

            provider.addScope("user:email");

            firebase
                .auth()
                .signInWithPopup(provider)
                .then(function (result: any) {
                    try {
                        const github = {
                            email: result.user && result.user.email,
                            userName: result.additionalUserInfo.username,
                            accessToken: result.credential && result.credential.accessToken
                        };
                        authHttp({ provider: socialType, data: github });
                        // setShowUserName(true);
                        // setSocial({ provider: social, data: github })
                        let { accessToken, ...details }: any = github
                        dispatch(saveDetails({...details, loginType: socialType}));
                    } catch (e) {
                        logger.error(e);
                    }
                })
                .catch(error => {
                    logger.error("error github firebase", error);
                    if (error.code !== "auth/popup-closed-by-user" && error.code !== "auth/cancelled-popup-request") {
                        ErrorToast(error.message)
                    }
                });
        }
    };

    const handleBtnClick = () => {
        if (usernameAvailable.username) {
            if (!usernameAvailable.available) {
                setUsernameAvailable({ ...usernameAvailable, loading: true });
                Http.get(`/user/check/${usernameAvailable.username}`).subscribe((res: any) => {
                    setUsernameAvailable({ ...usernameAvailable, showError: res.status, available: !res.status, loading: false });
                })
            } else {
                social.data = { ...social.data, userName: usernameAvailable.username };
                authHttp(social);
            }
        } else {
            setUsernameAvailable({ inputCheck: true })
        }
    }

    return (
        <>
            <div className="initialPage-container">
                <div className="heading">Hello!</div>
                <div className="subtext">Use your email or another service to continue with Uniphore.</div>
                <div onClick={() => socialSiginIn('google')} className="button-container">
                    <div className="button-text">
                        <img src={Google} alt="google-icon" />
                        <div>Continue with Google</div>
                    </div>
                </div>
                <div onClick={() => socialSiginIn('github')} style={{ marginTop: "24px" }} className="button-container">
                    <div className="button-text">
                        <img src={Github} alt="github-icon" />
                        <div>Continue with Github</div>
                    </div>
                </div>
                <Button onClick={() => history.push("/signin/email-signIn")} className="email-button" data-test-id="continue_with_email">Continue with email</Button>
                <div className="terms-text" style={{marginTop:"20px"}} >
                    <p>By continuing, you agree to our <a href="https://autonom8.com/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{fontWeight:600}} className="terms-link">Terms of Service & Privacy Policy</a></p>
                </div>
            </div>
            <Modal
                data-test-id="creation_cancelled"
                destroyOnClose={true}
                maskClosable={false}
                closable={true}
                visible={showUserName}
                footer={null}
                centered
                onCancel={() => {
                    setShowUserName(false)
                    setUsernameAvailable(initialUser);
                    ErrorToast('Account creation cancelled by user')
                }}
            >
                <div className={style.unamebody}>
                    <NewUser data-test-id="new_user" />
                    <label data-test-id="user_name" htmlFor="username" onClick={() => setShowUserName(false)}>Create user name</label>
                    <div style={{ display: "flex" }}>
                        <input data-test-id="username" type="text" name="username" id="username" onChange={e => setUsernameAvailable({ ...usernameAvailable, available: false, username: e.target.value.trim(), inputCheck: false, showError: false })} />
                        <button data-test-id="username_avail" onClick={() => handleBtnClick()} disabled={usernameAvailable.loading}>
                            {usernameAvailable.loading ? <Icon type="loading" spin style={{ fontSize: "28px" }} /> :
                                !usernameAvailable.available ? "Check availability" : "Create"}
                        </button>
                    </div>
                    {usernameAvailable.inputCheck && <div data-test-id="warning" className={style.error}>
                        <Alert type="warning" message="Please enter the username to check availability" showIcon />
                    </div>
                    }
                    {usernameAvailable.showError && <div data-test-id="error" className={style.error}>
                        <Alert type="error" message="Sorry! This username is already taken" showIcon />
                    </div>
                    }
                    {usernameAvailable.available && <div data-test-id="success" className={style.error}>
                        <Alert type="success" message="This username is available" showIcon />
                    </div>
                    }

                </div>
            </Modal>
        </>
    )
}

export default InitialPage;